import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICoreMemberDTO } from '@app/core/model';
import { SharedMemberService } from '@app/shared/services/shared-member.service';
import { ShellService } from '@mynexus/mfe-core';
import { ProductNames } from '@mynexus/mynexus-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class MemberPacService extends SharedMemberService {
  constructor(http: HttpClient, shellService: ShellService) {
    super(http, shellService, ProductNames.PACIM);
  }

  mapMemberDTO(memberDto: object): ICoreMemberDTO {
    const member = memberDto['member'];
    const benefit = memberDto['benefit'];

    return {
      memberId: member['memberId'],
      benefitPlanID: null, // Reviewed PACIM.API and source and destination for this input is not relevant to documents and is always null
      benefitPlanName: benefit['benefitPlanName'],
      firstName: member['firstName'],
      isEligible: benefit['isEligible'],
      lastName: member['lastName'],
      lineOfBusiness: benefit['lineOfBusiness'],
      streamData: {
        programState: benefit['programState'],
        utilizationReviewNumber: benefit['utilizationReviewNumber'],
       },
      subscriberNumber: member['subscriberNumber'],
      gender: member['gender'],
      dateOfBirth: member['dateOfBirth'],
      lineOfBusinessId: benefit['lineOfBusinessId'],
    };
  }
}
